























































































































import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { TableField } from '@/models/table-field.model';
import { routeName } from '@/constants/route.constants';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import VeterinarianModule, {
  VETERINARIAN_MODULE_NAME
} from '@/store/modules/veterinarian.module';
import RegisteredTagModule from '@/store/modules/registered-tag.module';
import { mapState } from 'vuex';
import { VeterinarianOffice } from '@/models/DTO/veterinarian-office/veterinarian-office.model';
import { TableContext } from '@/models/table-context.model';
import TableContextMixin from '@/mixins/table-context.mixin';
import { BaseAPIErrorModel } from '@/models/DTO/base-api-error.model';

const veterinarianModule: VeterinarianModule = getModule(
  VeterinarianModule,
  store
);

const registeredTagModule: RegisteredTagModule = getModule(
  RegisteredTagModule,
  store
);

@Component({
  computed: {
    routeName(): typeof routeName {
      return routeName;
    },
    ...mapState(VETERINARIAN_MODULE_NAME, [
      'showTableLoading',
      'veterinarianOffices',
      'errorResponse'
    ])
  }
})
export default class AccountListComponent extends mixins(TableContextMixin) {
  public showTableLoading: boolean;
  public veterinarianOffices: Array<VeterinarianOffice>;
  public errorResponse: BaseAPIErrorModel | null;
  public currentPage = 1;
  public recordsPerPage = 10;
  public sortBy = 'name';
  public sortDesc = false;
  public filter = '';
  public records = 0;

  public fields: Array<TableField> = [
    {
      key: 'name',
      sortable: true,
      stickyColumn: true
    },
    {
      key: 'erpNumber',
      sortable: true,
      label: 'ERP #'
    },
    {
      key: 'address1',
      sortable: true,
      label: 'Address'
    },
    {
      key: 'city',
      sortable: true,
      label: 'City'
    },
    {
      key: 'state',
      sortable: true,
      label: 'State'
    },
    {
      key: 'zipCode',
      sortable: true,
      label: 'Zip'
    },
    {
      key: 'dateModifiedUtc',
      sortable: true,
      label: 'Modified'
    },
    {
      key: 'id',
      sortable: false,
      label: '',
      tdClass: 'text-right',
      headerTitle: 'Edit veterinarian account actions.'
    }
  ];

  @Watch('veterinarianOffices', { deep: true })
  private onVeterinarianOfficesChanged() {
    return this.getNumberOfRecords();
  }

  @Watch('errorResponse', { deep: true })
  private onErrorResponseChanged(value: BaseAPIErrorModel) {
    if (value) {
      const errors = value.getAllErrorMessages();
      return this.$toasted.error(errors.join());
    }
  }

  public created() {
    this.filter = '';
    this.records = this.veterinarianOffices.length;

    this.getVetOffices();
  }

  public mounted() {
    if (this.currentTableContext) {
      this.currentPage = this.currentTableContext.currentPage;
      this.recordsPerPage = this.currentTableContext.perPage;
      this.sortBy = this.currentTableContext.sortBy;
      this.sortDesc = this.currentTableContext.sortDesc;
      this.filter = this.currentTableContext.filter;
    }
  }

  private async getVetOffices() {
    if (this.veterinarianOffices.length === 0) {
      await veterinarianModule.getVeterinarianOfficesAction();
    }
  }

  public getNumberOfRecords() {
    this.records = this.veterinarianOffices.length;
  }

  public onFiltered(filteredItems: Array<VeterinarianOffice>) {
    this.records = filteredItems.length;
    this.currentPage = 1;
  }

  public async onEditUsers(office: VeterinarianOffice) {
    if (office.id) {
      this.$router.push({
        name: routeName.admin.editUsers,
        params: { accountId: office.id }
      });
    }
  }

  public async onTagsClick(accountId: string) {
    await veterinarianModule.setSelectedVeterinarianOfficeIdAction(accountId);

    // no need to wait
    registeredTagModule.getAllTagsByVeterinarianOfficeIdAction(accountId);

    this.$router.push({
      name: routeName.admin.registrations
    });
  }

  public onContextChanged(context: TableContext) {
    this.setTableContext({
      ...context,
      pageName: this.page || ''
    });
  }

  public async onCreateAccount() {
    await veterinarianModule.newVeterinarianOfficeAction(null);

    this.$router.push({ name: routeName.admin.createAccount });
  }
}
